export const countries_data = [
  {
    key: '1',
    countryName: 'United States',
    countryCode: 'US',
    status: 'Active',
  },
  {
    key: '2',
    countryName: 'United Kingdom',
    countryCode: 'UK',
    status: 'Active',
  },
  {
    key: '3',
    countryName: 'New Zealand',
    countryCode: 'NZ',
    status: 'Active',
  },
  {
    key: '4',
    countryName: 'Italy',
    countryCode: 'IT',
    status: 'Active',
  },
  {
    key: '5',
    countryName: 'India',
    countryCode: 'IN',
    status: 'Active',
  },
  {
    key: '6',
    countryName: 'Germany',
    countryCode: 'DE',
    status: 'Active',
  },
  {
    key: '7',
    countryName: 'France',
    countryCode: 'FR',
    status: 'Active',
  },
  {
    key: '8',
    countryName: 'Canada',
    countryCode: 'CA',
    status: 'Active',
  },
  {
    key: '9',
    countryName: 'Australia',
    countryCode: 'AU',
    status: 'Active',
  },
  {
    key: '10',
    countryName: 'Argentina',
    countryCode: 'AR',
    status: 'Active',
  },
];
